import { useNavigate } from "react-router-dom";
import { Plus, Trash2 } from "lucide-react";


export default function BlogDashboard() {
  const navigate = useNavigate();

  return (
    
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <h1 className="text-3xl font-bold mb-6">Manage Blogs</h1>
      <div className="grid grid-cols-3 gap-8 w-full max-w-3xl">
        <ActionButton icon={<Plus size={40} />} text="Create Blog" onClick={() => navigate("/blogs/create")} />
        <ActionButton icon={<Trash2 size={40} />} text="Delete Blog" onClick={() => navigate("/blogs/delete")} />
      </div>
      <button
        onClick={() => navigate("/")}
        className="mt-8 bg-gray-800 text-white px-6 py-3 rounded-lg hover:bg-gray-700 transition"
      >
        Back to Dashboard
      </button>
    </div>
  );
}

// Reusable Button Component
function ActionButton({ icon, text, onClick }) {
  return (
    <button
      onClick={onClick}
      className="w-full h-40 flex flex-col justify-center items-center border-2 border-gray-400 hover:border-gray-600 rounded-lg bg-white transition-all text-gray-900 text-lg font-semibold shadow-md hover:shadow-xl"
    >
      {icon}
      <span className="mt-2">{text}</span>
    </button>
  );
}
